/**
 * Set factoring contact
 * @param {Object} contact - Contact Object.
 */
export const set = ({ commit }, contact) => {
  return new Promise((resolve) => {
    commit('SET_RESIDENCE', contact.residence)
    commit('SET_CORPORATE_NAME', contact.name)
    commit('SET_TRADENAME', contact.tradeName)
    commit('SET_DOCUMENT', contact.document)
    if (contact.address) {
      commit('SET_ADDRESS_STREET', contact.address.street)
      commit('SET_ADDRESS_POSTALCODE', contact.address.postalCode)
      commit('SET_ADDRESS_TOWN', contact.address.town)
      commit('SET_ADDRESS_CITY', contact.address.city)
      commit('SET_ADDRESS_COUNTRY', contact.address.country)
    }
    if (contact.registrationData) {
      commit('SET_REGISTRATION_BOOK', contact.registrationData.book)
      commit('SET_REGISTRATION_FOLIO', contact.registrationData.folio)
      commit('SET_REGISTRATION_SHEET', contact.registrationData.sheet)
      commit('SET_REGISTRATION_SECTION', contact.registrationData.section)
      commit('SET_REGISTRATION_VOLUME', contact.registrationData.volume)
      commit('SET_REGISTRATION_MERCANTILE_REGISTRY', contact.registrationData.mercantileRegistry)
      commit('SET_REGISTRATION_ADDITIONAL_INFO', contact.registrationData.additionalRegistrationData)
    }
    if (contact.medium) {
      commit('SET_MEDIUM_MAIL', contact.medium.email)
      commit('SET_MEDIUM_FAX', contact.medium.fax)
      commit('SET_MEDIUM_PHONE', contact.medium.phone)
      commit('SET_MEDIUM_WEB', contact.medium.web)
      commit('SET_MEDIUM_CONTACT_PERSON', contact.medium.name)
      commit('SET_MEDIUM_ADDITIONAL_INFO', contact.medium.additionalContactDetails)
    }
    resolve()
  })
}

export const empty = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_RESIDENCE', undefined)
    commit('SET_CORPORATE_NAME', undefined)
    commit('SET_TRADENAME', undefined)
    commit('SET_DOCUMENT', undefined)
    commit('SET_ADDRESS_STREET', undefined)
    commit('SET_ADDRESS_POSTALCODE', undefined)
    commit('SET_ADDRESS_TOWN', undefined)
    commit('SET_ADDRESS_CITY', undefined)
    commit('SET_ADDRESS_COUNTRY', undefined)
    commit('SET_REGISTRATION_BOOK', undefined)
    commit('SET_REGISTRATION_FOLIO', undefined)
    commit('SET_REGISTRATION_SHEET', undefined)
    commit('SET_REGISTRATION_SECTION', undefined)
    commit('SET_REGISTRATION_VOLUME', undefined)
    commit('SET_REGISTRATION_MERCANTILE_REGISTRY', undefined)
    commit('SET_REGISTRATION_ADDITIONAL_INFO', undefined)
    commit('SET_MEDIUM_MAIL', undefined)
    commit('SET_MEDIUM_FAX', undefined)
    commit('SET_MEDIUM_PHONE', undefined)
    commit('SET_MEDIUM_WEB', undefined)
    commit('SET_MEDIUM_CONTACT_PERSON', undefined)
    commit('SET_MEDIUM_ADDITIONAL_INFO', undefined)
    resolve()
  })
}
